import Repository from './Repository'

const resource = 'services'

export default {
  getServices (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  getService (tenantId, serviceId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/${serviceId}`, { params: params })
  },
  createService (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateService (tenantId, serviceId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${serviceId}`, data)
  },
  getServiceGroups (serviceId, params) {
    return Repository.get(`${resource}/${serviceId}/groups`, { params: params })
  }
  // getResultHorseExercise (tenantId, horseId, exerciseId, params) {
  //   return Repository.get(`tenants/${tenantId}/${resource}/${horseId}/exercise/${exerciseId}/results`, { params: params })
  // }
}
